import { Capacitor } from '@capacitor/core'

/**
 * Custom URL scheme used to bring the user back into the native app after completing
 * Stripe Checkout in the in-app browser sheet (see usePaymentIntro / usePaymentReturnListener).
 * Must match the scheme registered in ios/App/App/Info.plist and android/app/src/main/AndroidManifest.xml.
 */
export const PAYMENT_RETURN_SCHEME = 'com.relentless2800.challenge'
const PAYMENT_RETURN_HOST = 'payment-callback'

/** Store builds that predate @capacitor/app can't receive the return deep link. */
export function needsAppUpdateForCheckout() {
  return Capacitor.isNativePlatform() && !Capacitor.isPluginAvailable('App')
}

export function buildPaymentReturnUrl(targetPath: string) {
  return `${PAYMENT_RETURN_SCHEME}://${PAYMENT_RETURN_HOST}?target=${encodeURIComponent(targetPath)}`
}

/** Returns the in-app path to navigate to, or undefined if `url` isn't a payment-return deep link. */
export function parsePaymentReturnUrl(url: string): string | undefined {
  if (!url.startsWith(`${PAYMENT_RETURN_SCHEME}://${PAYMENT_RETURN_HOST}`)) return undefined
  const target = new URL(url).searchParams.get('target')
  return target ? decodeURIComponent(target) : undefined
}
